import styled from "styled-components";
import { Button } from "../../AppStyle";

export const Wrapper = styled.div`
  padding: 40px;

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20%;
    flex-wrap: wrap;
  }

  .content img {
    width: 500px;
    height: auto;
    flex-shrink: 0;
    margin: 0 8px 0 0;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    max-width: 400px;
    text-align: left;
  }

  .title {
    font-size: 32px;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
    margin-bottom: 20px;
  }
  .title span {
    color: #dddf21;
  }

  .description {
    font-size: 18px;
    color: ${({ theme }) => theme.text};
    margin-bottom: 30px;
    line-height: 1.4;
    word-spacing: 5px;
  }

  @media screen and (max-width: 768px) {
    padding: 20px 20px;

    .content {
      flex-direction: column-reverse;
      align-items: center;
    }

    .content img {
      width: 100%;
      max-width: 300px;
      margin: 0 0 20px;
    }

    .text-content {
      width: 100%;
      max-width: 350px;
      margin: 0 auto 20px;
      text-align: flex-start;
      padding: 0 10px;
    }

    .title {
      font-size: 28px;
    }
    .description {
      font-size: 16px;
    }
  }
`;

export const HeroButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  border-radius: 15px;
  border: none;
  background: #dddf21;
  color: #242424;
  font-size: 15px;
  font-weight: 500;

  &:hover {
    background-color: rgba(36, 36, 36, 0.54);
    color: black;
    transition-duration: 0.1s;
  }

  &:active {
    background-color: rgb(19, 19, 19);
    color: black;
    transition-duration: 0.1s;
  }

  @media screen and (max-width: 1200px) {
    width: 100%;
    max-width: 400px;
    height: 3rem;
    font-size: 17px;
    margin: 20px auto 30px;
    border-radius: 30px;
  }
`;
